import { render, staticRenderFns } from "./SolicitaCertificado.vue?vue&type=template&id=ea78002a&scoped=true"
import script from "./SolicitaCertificado.vue?vue&type=script&lang=js"
export * from "./SolicitaCertificado.vue?vue&type=script&lang=js"
import style0 from "./SolicitaCertificado.vue?vue&type=style&index=0&id=ea78002a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea78002a",
  null
  
)

export default component.exports